__turbopack_context__.v({
  "app_light_theme": "pagination-new-module-scss-module__isR0dW__app_light_theme",
  "moreButton": "pagination-new-module-scss-module__isR0dW__moreButton",
  "nav": "pagination-new-module-scss-module__isR0dW__nav",
  "page": "pagination-new-module-scss-module__isR0dW__page",
  "page--active": "pagination-new-module-scss-module__isR0dW__page--active",
  "page--ellipsis": "pagination-new-module-scss-module__isR0dW__page--ellipsis",
  "pages": "pagination-new-module-scss-module__isR0dW__pages",
  "root": "pagination-new-module-scss-module__isR0dW__root",
});
